"use strict";

exports.__esModule = true;
exports.UiDesignProvider = UiDesignProvider;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _EnvContext = require("../../Env/EnvContext");
var _UiPreferencesContext = require("../../UiPreferences/UiPreferencesContext");
var _UiDesignContext = require("./UiDesignContext");
var _resolveUiDesign = require("./resolveUiDesign");
var _modernOverlay = require("./modernOverlay");
var _ModernGlobalStyles = require("./ModernGlobalStyles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/**
 * Decides whether its subtree renders the modern UI and provides the matching
 * theme. Mount one without `screen` around the app chrome (it reads the
 * master flag and renders the modern global styles) and one per route group
 * with the screen's name; a screen whose flag is off gets the legacy tokens
 * back even when the chrome is modern.
 */
function UiDesignProvider(_ref) {
  var screen = _ref.screen,
    children = _ref.children;
  var env = (0, _react.useContext)(_EnvContext.EnvContext) || {};
  // The user's saved choices, applied over the environment's flags when a
  // UiPreferencesProvider is mounted above.
  var _useContext = (0, _react.useContext)(_UiPreferencesContext.UiPreferencesContext),
    effectiveFlags = _useContext.effectiveFlags;
  var featureFlags = effectiveFlags || env.featureFlags;
  var parent = (0, _react.useContext)(_UiDesignContext.UiDesignContext);
  var outerTheme = (0, _react.useContext)(_styledComponents.ThemeContext);
  var modern = (0, _resolveUiDesign.resolveUiDesign)(featureFlags, screen);
  var isRoot = parent.baseTheme === undefined;
  var baseTheme = isRoot ? outerTheme : parent.baseTheme;

  // A function theme: styled-components uses its result as-is, whereas an
  // object theme is merged over the outer one, which would let `uiModern`
  // and the overlay leak from a modern chrome into a legacy screen.
  var theme = (0, _react.useMemo)(function () {
    var resolved = modern ? (0, _modernOverlay.modernTheme)(baseTheme) : Object.assign({}, baseTheme || {}, {
      uiModern: false
    });
    return function () {
      return resolved;
    };
  }, [modern, baseTheme]);
  var value = (0, _react.useMemo)(function () {
    return {
      modern: modern,
      screen: screen,
      baseTheme: baseTheme
    };
  }, [modern, screen, baseTheme]);
  return /*#__PURE__*/_react["default"].createElement(_UiDesignContext.UiDesignContext.Provider, {
    value: value
  }, /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, isRoot && modern && /*#__PURE__*/_react["default"].createElement(_ModernGlobalStyles.ModernGlobalStyles, null), children));
}